/**
 * @file PlanNotEligibleScreen.tsx
 *
 * Terminal screen shown when the authenticated project's plan is not shop-eligible
 * (not Commerce, and not an unexpired trial). The admin is never rendered for
 * these projects.
 */

import { useIntl } from 'react-intl';
import { messages } from '../i18n/messages';
import { NoticeScreen } from './NoticeScreen';

export function PlanNotEligibleScreen() {
  const intl = useIntl();
  return (
    <NoticeScreen
      title={intl.formatMessage(messages.planNotEligibleTitle)}
      body={intl.formatMessage(messages.planNotEligibleBody)}
    />
  );
}
